import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { PropsWithChildren, useId } from 'react';

interface Props extends PropsWithChildren {
  open?: boolean;
  onClose?(value: boolean): void;
  title?: string;
  acceptButtonLabel?: string;
  cancelButtonLabel?: string;
}

export const AlertDialog: React.FC<Props> = ({
  children,
  open,
  onClose,
  title,
  cancelButtonLabel,
  acceptButtonLabel,
}) => {
  const labelId = useId();
  const descriptionId = useId();

  const handleClose = (value: boolean) => {
    if (onClose) onClose(value);
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      aria-labelledby={labelId}
      aria-describedby={descriptionId}
    >
      {title && <DialogTitle id={labelId}>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id={descriptionId}>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {cancelButtonLabel && (
          <Button
            onClick={() => {
              handleClose(false);
            }}
          >
            {cancelButtonLabel}
          </Button>
        )}
        {acceptButtonLabel && (
          <Button
            onClick={() => {
              handleClose(true);
            }}
            autoFocus
          >
            {acceptButtonLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
